import Contact from "../components/sections/Contact";
import { motion } from "framer-motion";
import useSEO from "../lib/useSEO";

export default function ContactPage() {
    useSEO({
        title: "Contact Thooyra Technologies — Build Custom Software in Chennai",
        description:
            "Get in touch with Thooyra Technologies. Email support@thooyra.in or WhatsApp +91 79755 11832 to discuss your ERP, SaaS, mobile or cloud software project.",
        path: "/contact",
    });
    return (
        <main data-testid="contact-page">
            <section className="relative pt-36 pb-4 md:pt-44 overflow-hidden">
                <div
                    aria-hidden
                    className="absolute inset-0 -z-10 pointer-events-none"
                >
                    <div className="absolute top-0 right-1/4 w-[420px] h-[420px] rounded-full bg-violet-300/30 dark:bg-violet-500/20 blur-[120px] animate-blob" />
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <motion.div
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            Contact
                        </div>
                        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                            Let&apos;s build something{" "}
                            <span className="italic font-medium">
                                meaningful
                            </span>{" "}
                            together.
                        </h1>
                    </motion.div>
                </div>
            </section>
            <Contact />
        </main>
    );
}
